'use strict';


import { Report } from './QAReport';
import { resourcesFolder } from '../../settings';
import { Cloudflare } from '../api/Cloudflare';

export class QARotor extends Report{
	constructor () {
		super('Rotor');
	}
	
	async validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		const response = await fetch(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/litemod/rotor/rotor.json?v=${Cloudflare.version}`);
		
		if (response.status !== 200) {
			this.addError('Rotor: rotor.json','Not found');
		}
		
		this.normalize();
		this.showReport();
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => {
				this.jsonReport.push(`${errorData.apt} - ${errorData.message}`);
			});
		}
	}
	
}
